var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-layout',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('section-title',{attrs:{"title":"Правовая информация"}}),_c('legal-docs-list'),_c('cookies-use-form')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }